import React, { useEffect, useState } from 'react';
import Head from 'next/head';
import generateMetaData from 'lib/utils/generateMetaData';
import { LazyLoad } from 'views/common/components';
import StyledBox from 'views/rebranded-module/information-module/AboutUsViewV2/AboutUsViewV2.styles';
import {
  HeroSection,
  HeroSectionSkeleton,
  ExperienceSection,
  ExperienceSectionSkeleton,
  LeadershipSection,
  LeadershipSectionSkeleton,
  FutureSection,
  FutureSectionSkeleton,
  BannerSection,
  BannerSectionSkeleton,
} from 'views/rebranded-module/information-module/AboutUsViewV2/components';
import useErrorsHandler from 'views/rebranded-module/common/hooks/useErrorsHandler';
import axios, { API } from 'lib/config/axios';

interface AboutUsViewV2Props {
  serverData: any;
}

const AboutUsViewV2: React.FC<AboutUsViewV2Props> = (props) => {
  const { serverData } = props;
  const handleErrorResponse = useErrorsHandler();
  const [seoValues, setSeoValues] = useState(serverData?.seo_values);
  const getSeoValuesData = () => {
    axios
      .get(API.seoValues, {
        params: {
          preferred_seo_identifer: 'about-us-history-page',
        },
      })
      .then((res) => {
        setSeoValues(res.data);
      })
      .catch((error) => {
        handleErrorResponse(error, false);
      });
  };

  useEffect(() => {
    if (!serverData) {
      getSeoValuesData();
    }
  }, []);

  return (
    <StyledBox>
      {seoValues && <Head>{generateMetaData(seoValues)}</Head>}
      
      <LazyLoad skeleton={<HeroSectionSkeleton />} dataLoaded>
        <HeroSection />
      </LazyLoad>
      <LazyLoad skeleton={<ExperienceSectionSkeleton />} dataLoaded>
        <ExperienceSection />
      </LazyLoad>
      <LazyLoad skeleton={<LeadershipSectionSkeleton />} dataLoaded>
        <LeadershipSection />
      </LazyLoad>
      <LazyLoad skeleton={<FutureSectionSkeleton />} dataLoaded>
        <FutureSection />
      </LazyLoad>
      <LazyLoad skeleton={<BannerSectionSkeleton />} dataLoaded>
        <BannerSection />
      </LazyLoad>
    </StyledBox>
  );
};

export { AboutUsViewV2 };
